import { Injectable } from '@angular/core';
import {AccountService, AuthServerProvider} from '..';
import {HttpClient} from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(private accountService: AccountService,
              private authServerProvider: AuthServerProvider,
              protected http: HttpClient
              ) {}

  login(credentials, callback?) {
    const cb = callback || function() {};

    return new Promise((resolve, reject) => {
      this.authServerProvider.login(credentials).subscribe(
        data => {
          resolve(data);
          return cb();
        },
        err => {
          this.logout();
          reject(err);
          return cb(err);
        }
      );
    });
  }

  loginWithToken(jwt, rememberMe) {
    return this.authServerProvider.loginWithToken(jwt, rememberMe);
  }

  getToken(): string {
    return this.authServerProvider.getToken();
  }

  logout() {
    this.authServerProvider.logout().subscribe(null, null,
      () => {
        this.accountService.authenticate(null);
      });
  }

}
